<template>
  <div id="userLayout" :class="['user-layout-wrapper', device]">
    <div class="container">
      <div v-if="routeName !== 'CommonLogin'" class="top">
        <div class="left">
          <logo :showTitle="true" />
          <span class="divider">|</span>
          <span>{{ routeTitle }}</span>
        </div>
        <a-button
          style="color: #fff;"
          type="link"
          @click="handleClick"
        ><span style="position: relative; top: 1px;">登录</span>
          <sass-icon
            type="hi-arrow-right"
            style="font-size: 18px; vertical-align: middle;"
          />
        </a-button>
      </div>
      <route-view />
      <div class="footer"></div>
    </div>
  </div>
</template>

<script>
import Logo from '@/layouts/tools/Logo'
import RouteView from './RouteView'
import { mapActions } from 'vuex'
import CommonIcon from '@/components/common-icon'
import { ACCESS_TOKEN } from '@/store/mutation-types'

export default {
  name: 'LoginLayout',
  components: { Logo, RouteView, CommonIcon },
  data() {
    return {
      device: 'desktop'
    }
  },
  computed: {
    routeName() {
      return this.$route.name
    },
    routeTitle() {
      return this.$route.meta.title
    }
  },
  methods: {
    ...mapActions(['Logout']),
    handleClick() {
      const { Logout } = this
      if (this.$cookie.get(ACCESS_TOKEN)) {
        Logout().catch((err) => {
          this.$message.error({
            title: '错误',
            description: err.msg
          })
        })
      } else {
        this.$router.replace({ name: 'CommonLogin' })
      }
    }
  },
  mounted() {
    document.body.classList.add('userLayout')
  },
  beforeDestroy() {
    document.body.classList.remove('userLayout')
  }
}
</script>

<style lang="less" scoped>
// /deep/svg {
//   color: #ffffff!important;
// }
/deep/i.normal-logo.anticon {
  // border: 1px solid red;
  margin-top: 3px;
}
#userLayout.user-layout-wrapper {
  height: 100%;
  .container {
    // overflow: hidden;
    overflow: auto;
    // padding: 110px 0 144px;
    position: relative;
    width: 100%;
    height: 100%;
    // background: #f0f2f5 url(~@/assets/background.svg) no-repeat 50%;
    background: #f0f2f5;
    background-size: 100%;
    .top {
      display: flex;
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      z-index: 1000;
      padding: 0 24px;
      color: #fff;
      // height: 64px;
      // background: #fff;
      background: #262728;
      justify-content: space-between;
      align-items: center;
    }
    .left {
      display: flex;
      align-items: center;
      .logo {
        overflow: hidden;
        line-height: 64px;
        -webkit-transition: all .3s;
        transition: all .3s;
        /deep/svg {
          display: inline-block;
          overflow: hidden;
          // color: #00A497;
          margin-bottom: 6px;
          width: 100px;
          height: 44px;
          vertical-align: middle;
          transform: scale(.8);
          fill: currentColor;
        }
      }
    }
    h1 {
      font-size: 28px;
      color: inherit;
    }
    .divider {
      margin: 0 24px;
      color: #999;
    }
    .main {
      margin: 0 auto;
      width: 368px;
      min-width: 260px;
    }
    .footer {
      position: absolute;
      bottom: 0;
      margin: 48px 0 24px;
      padding: 0 16px;
      width: 100%;
      text-align: center;
      .links {
        margin-bottom: 8px;
        font-size: 14px;
        a {
          color: rgba(0, 0, 0, .45);
          transition: all .3s;
          &:not(:last-child) {
            margin-right: 40px;
          }
        }
      }
      .copyright {
        font-size: 14px;
        color: rgba(0, 0, 0, .45);
      }
    }
  }
}
</style>
<style></style>
